import controller from './pie-chart.controller';
import template from './pie-chart.html';

export default {
	template,
	bindings: {
		data: '<',
		options: '<',
	},
	controller,
};
